import { detectedTimezoneSelector, timezoneFromQuerySelector } from 'selectors'

export const changeTimezone = (timezoneId) => ({
  type: 'CHANGE_TIMEZONE',
  timezone: timezoneId
})

export const acceptTimezonePopup = () => (
  (dispatch, getState) => {
    const state = getState()
    const timezone = detectedTimezoneSelector(state)
    dispatch(changeTimezone(timezone))
  }
)

export const dismissTimezonePopup = () => (
  (dispatch, getState) => {
    const state = getState()
    const timezone = timezoneFromQuerySelector(state)
    dispatch(changeTimezone(timezone))
  }
)
